import React from 'react';
import i18next from 'i18next';
import Spinner from 'react-spinkit';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Scrollbars } from 'react-custom-scrollbars';
import Api from '../../../api';
import { numberWithSpaces } from '../../../utils';
import makeCancelable from '../../../api/cancelable';

class History extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      history: null,
      copied: false,
    };

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  componentDidMount() {
    const { promise, cancel } = makeCancelable(
      Api.ordersHistory(this.props.hash)
    );
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          history: response.data,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.state.copied) {
      this.timer = setTimeout(() => {
        this.setState({
          copied: false,
        });
      }, 300);
    }
  }

  render() {
    const { history, copied } = this.state;
    const { hash, cf } = this.props;

    return (
      <div className="crash-history">
        <div className="crash-history__cf"> {cf}X</div>
        <div className="crash-history__hash">
          hash
          <br />
          <CopyToClipboard
            text="hash"
            className={'crash-history__hash-value' + (copied ? ' copied' : '')}
            onCopy={() => this.setState({ copied: true })}
          >
            <span>{hash}</span>
          </CopyToClipboard>
        </div>

        {!history && (
          <div className="crash-history__loading">
            <div>{i18next.t('loading')}</div>
            <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
          </div>
        )}

        {history && history.length === 0 && (
          <div className="crash-history__empty">
            {i18next.t('crash.history.bets_empty')}
          </div>
        )}

        {history && history.length > 0 && (
          <div className="table">
            <div className="table__header">
              <span className="table__col">
                {i18next.t('crash.history.bets_table_nick')}
              </span>
              <span className="table__col">
                {i18next.t('crash.history.bets_table_bet')}
              </span>
              <span className="table__col">
                {i18next.t('crash.history.bets_table_x')}
              </span>
              <span className="table__col">
                {i18next.t('crash.history.bets_table_win')}
              </span>
            </div>
            <div className="table__body">
              <Scrollbars
                hideTracksWhenNotNeeded={true}
                autoHeight={true}
                autoHeightMin={30}
                autoHeightMax={400}
                renderView={(props) => (
                  <div {...props} className="table__rows" />
                )}
              >
                {history.map((item, i) => (
                  <div key={i}>
                    <span className="table__col">{item.username}</span>
                    <span className="table__col">{item.summ}</span>
                    <span className="table__col">
                      {+item.status ? item.price : 0}
                    </span>
                    <span
                      className={
                        'table__col' + (+item.status === 1 ? ' win' : ' loose')
                      }
                    >
                      {+item.status
                        ? '+' +
                          numberWithSpaces(Math.floor(item.summ * item.price))
                        : -item.summ}
                    </span>
                  </div>
                ))}
              </Scrollbars>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./app/components/CrashGame/History/History.jsx